export default class Utils {
    static guidGenerator() {
        const s4 = function () {
            return (((1 + Math.random()) * 0x10000) | 0).toString(16).substring(1);
        };
        return (s4() + s4() + "-" + s4() + "-" + s4() + "-" + s4() + "-" + s4() + s4() + s4());
    }
    static lsGet<T>(key: string): T {
        const val = localStorage.getItem(key);
        if (val)
            return (JSON.parse(val));

        //console.log("Unexpected error in lsGet. No value for key", key);
        return (undefined);
    }

    static lsSet<T>(key: string, value: T): T {
        if (value) {
            localStorage.setItem(key, JSON.stringify(value));
            return value;
        }

        //console.log("Unexpected error in lsSet. No value for key", key);
        return (undefined);
    }

    static lsRemove(key: string) {
            localStorage.removeItem(key);
    }

    // True when this page runs inside one of the hidden iframes ADAL uses for silent token renewal
    // (ids "adalIdTokenFrame" / "adalRenewFrame<resource>"). Teams also hosts us in an iframe, but
    // that parent is cross-origin, so frameElement is null there.
    static isAdalFrame() {
        try {
            return !!window.frameElement && (window.frameElement.id || "").indexOf("adal") === 0;
        } catch (e) {
            return false;
        }
    }
    
    
    static orderAlphabetically(a,b){
        if(a > b) return 1
        return -1
    }


    static filterChatApplications = (linkedUser) => {

        let chatApps = [];
        if(linkedUser != null && linkedUser.length > 0) {
        
            let applications = linkedUser.map(user => user.application);
            let hasOtherApplicationsThanLeap = applications.some(app => app != null && app !== "" && app !== "leap");
            applications.forEach((application, i) => {
                if (application != null && application !== "" && !chatApps.includes(application)) {
                    
                    if(application.startsWith("Teams")) {
                        application = "Teams";
                    }

                    if(chatApps.includes(application)){
                        return;
                    }

                    if(hasOtherApplicationsThanLeap && application == "leap") {
                        return;
                    }

                   chatApps.push(application);
                }
             });
        }
        return chatApps;
    };
}